export const DONATION_SHARE = 0.8
